<template>
  <div
    class="kpi-stat-card"
    :class="{
      'kpi-stat-card--highlight': highlight,
      'kpi-stat-card--alert': variant === 'alert'
    }"
  >
    <div class="kpi-stat-card__label">
      {{ label }}
    </div>
    <div class="kpi-stat-card__value">
      {{ value }}
    </div>
    <div
      v-if="sublabel"
      class="kpi-stat-card__sublabel"
    >
      {{ sublabel }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseKpiStatCard',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    sublabel: {
      type: String,
      required: false,
      default: ''
    },
    highlight: {
      type: Boolean,
      required: false,
      default: false
    },
    variant: {
      type: String,
      required: false,
      default: 'default',
      validator: (value) => ['default', 'alert'].includes(value)
    }
  }
}
</script>

<style lang="scss">
.kpi-stat-card {
  background: var(--ds-color-black-005);
  border: 1px solid var(--ds-color-black-010);
  border-radius: 8px;
  padding: 16px;

  &--highlight {
    background: var(--v-primaryFaint-base);
    border-color: var(--v-primary-lighten4);
  }

  &--alert {
    border-color: var(--v-warning-base);

    .kpi-stat-card__value {
      color: var(--v-warning-base);
    }
  }

  &__label {
    font-size: 0.875rem;
    color: var(--ds-color-black-055);
    font-weight: 500;
    margin-bottom: 6px;
  }

  &__value {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.01em;
    margin-bottom: 4px;
    color: var(--v-textPrimary-base);
  }

  &__sublabel {
    font-size: 0.8rem;
    color: var(--ds-color-black-040);
  }
}
</style>
